// extracted by mini-css-extract-plugin
export default {"RegItemImage":"RegItemImage-styles__RegItemImage__Ex_Ac","RegItemImage__image":"RegItemImage-styles__RegItemImage__image__vHEEu"};